export default __webpack_public_path__ + "static/masthead_bg_mobile-c50c4914cc432e1608c81236d57ee724.png";